<template>
  <a-menu-item :key="routeChildren.path" @click.capture="handleLink" class="left-menu-item">
    <img v-if="routeChildren.meta.img" :src="routeChildren.meta.img" class="img" />
    <img v-else-if="routeChildren.meta.hotImg" :src="routeChildren.meta.hotImg" class="hot-img" />
    <VabIcon v-else :icon="routeChildren.meta.icon" style="margin-right: 4px"></VabIcon>
    <span :style="{ 'margin-left': !routeChildren.meta.hotImg ? '8px' : '29px' }">
      {{ routeChildren.meta.title }}
    </span>
  </a-menu-item>
</template>
<script>
import VabIcon from "@/layout/vab-icon";
export default {
  name: "MenuItem",
  components: { VabIcon },
  props: {
    item: {
      type: Object,
      default() {
        return null;
      },
    },
    routeChildren: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    handleLink() {
      if (this.routeChildren.meta.url) {
        window.open(this.routeChildren.meta.url);
        return;
      }
      const routePath = this.routeChildren.path;
      this.$router.push({ path: routePath });
    },
  },
};
</script>
<style lang="less">
.ant-menu-submenu {
  .ant-menu-submenu-title {
    padding-left: 14px !important;
    .ant-menu-title-content {
      .anticon + span {
        margin-left: 0;
      }
    }
  }
}
.left-menu-item {
  padding-left: 14px !important;
  .ant-menu-title-content {
    span {
      margin-left: 7px !important;
      text-align-last: justify;
      display: inline-block;
      width: 81px;
    }
  }
  .img {
    width: 20px;
    height: 20px;
    margin-right: 2px;
    vertical-align: sub;
  }
  .hot-img {
    width: 31px;
    height: 31px;
    position: relative;
    top: -4px;
    left: -7px;
    margin-right: -10px;
  }
}
.ant-menu-sub .left-menu-item {
  padding-left: 27px !important;
}
.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {
  > .ant-menu-title-content {
    text-align-last: justify;
    line-height: 1;
    width: 90px;
    text-overflow: unset !important;
    .anticon + span {
      display: inline-block;
      width: 82px;
      margin-left: 8px;
    }
  }
  > .ant-menu-submenu-arrow::before,
  > .ant-menu-submenu-arrow::after {
    width: 7px;
  }
}
</style>
